import React from 'react';
import { Person } from '@qover-private/protos-web/qover/dojo/travel/v1/person';
import { FormSpy } from 'react-final-form';
import { Trans } from '@lingui/macro';
import { toDate, subDays, isAfter } from '@qover/utils/src/date';

export const WarningEngine = ({ mutators: { setFieldData } }: any) => (
  <FormSpy
    subscription={{ values: true }}
    onChange={({ values }) =>
      values.risk.childrenList.forEach((child: Person, idx: number) =>
        setFieldData(`risk.childrenList[${idx}].birthdate`, {
          warning:
            typeof child.birthdate === 'string' &&
            isAfter(toDate(child.birthdate), subDays(new Date(), 14)) ? (
              <Trans id="travel.warning.tooYoung" />
            ) : undefined,
        }),
      )
    }
  />
);
